import { Drawer } from "@mui/material";
import React, { useState } from "react";
import EditProfile from "./EditProfile/EditProfile";
import ViewProfile from "./ViewProfile/ViewProfile";
// import PropTypes from 'prop-types'

const ProfileComponent = (props: any) => {
  // const classes = useStyles();
  const { onClose, open } = props;
  const [isEdit, setIsEdit] = useState(false);
  const handleClose = () => {
    onClose({ type: "profile" });
  };
  const changeEditState = () => {
    setIsEdit(true);
  };

  return (
    <Drawer
      aria-labelledby="simple-dialog-title"
      open={open}
      anchor="right"
      onClose={handleClose}
    >
      <span id="simple-dialog-title"></span>
      {/* <DialogTitle id="simple-dialog-title" className="pw-text">
        Reset Password
      </DialogTitle> */}
      {!isEdit ? (
        <ViewProfile openEdit={changeEditState} onClose={handleClose} />
      ) : (
        <EditProfile onClose={handleClose} />
      )}
    </Drawer>
  );
};

// ProfileComponent.propTypes = {}

export default ProfileComponent;
